module.exports = __webpack_public_path__ + "img/CH.72a82891.svg";